<template lang="pug">
 v-container(fill-height)
    v-layout(justify-center align-center)
      .auth-fields.text-center
        a(href="https://simplymotion.de")
          v-img.mx-auto.mb-12(src="@/assets/img/logo_simplymotion_white.png" max-width="300" contain )
        v-card.full-width.elevation-25.pt-2
          v-alert.mx-4(type="error" v-if="error") {{error}}
          v-card-title {{$t('auth.resetPassword.title')}}
          v-card-subtitle {{$t('auth.resetPassword.subtitle')}}
          v-card-text
      
            v-form.text-center(v-model='valid' ref="form")
              v-text-field.mt-4(v-model='username' :label="$t('auth.forms.email')" filled rounded type='email' :rules='[required, email]')
              v-text-field(v-model='code' label='Code' type="text" filled rounded  :rules='[required]')
              v-btn.my-5(large depressed=''  color='accent' @click='submit') {{$t('general.done')}}
        v-btn.mt-4(@click='resend' text) {{$t('auth.forms.resendCode')}}

</template>

<script>
import { confirmSignUp, resendSignUp } from "@/services/auth.js";
import validations from "@/utils/validations";
export default {
  name: "SignUpConfirm",
  data() {
    return {
      valid: false,
      username: "",
      code: "",
      ...validations,
      error: null,
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        confirmSignUp(this.username, this.code);
      }
    },
    resend() {
      if (this.username != "") {
        resendSignUp(this.username).catch(() => {
          this.$store.dispatch("shared/SET_SNACKBAR_TIMER", {
            visible: true,
            text: "Das hat leider nicht geklappt.",
          });
        });
      } else {
        this.$store.dispatch("shared/SET_SNACKBAR_TIMER", {
          visible: true,
          text: "Bitte erst deine E-Mail-Adresse eingeben",
        });
      }
    },
  },
};
</script>
